import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql, navigate } from 'gatsby'
import styled from '@emotion/styled'
import { Dropdown } from '@leshen/ui'

const StateDropdown = ({ aoa = '', spanish = false, ...props }) => {
  const [stateLinks, setStateLinks] = useState([])
  const [isDataFetched, setIsDataFetched] = useState(false)

  const data = useStaticQuery(graphql`
    query StateDropdownQuery {
      site {
        siteMetadata {
          datasetManagerAPIKey
        }
      }
    }
  `)

  const getFullStateName = (shortName) => {
    const states = {
      AL: 'Alabama',
      AK: 'Alaska',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      FL: 'Florida',
      GA: 'Georgia',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PA: 'Pennsylvania',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming',
    }
    return states[shortName]
  }

  useEffect(() => {
    const { datasetManagerAPIKey } = data.site.siteMetadata
    const stateDatasetUrl = `https://dm.clear.link/api/datasets/${aoa}/find?search[Area_Type]=state`

    fetch(stateDatasetUrl, {
      headers: {
        'X-Api-Key': datasetManagerAPIKey,
      },
    })
      .then((res) => (res?.ok ? res.json() : null))
      .then((d) => {
        const states = d?.dataset?.data || []
        const options = states
          .map((currentState) => ({
            label: getFullStateName(currentState.State),
            value: currentState.Page_Path,
          }))
          .sort((a, b) => a?.label?.localeCompare(b?.label))

        setStateLinks(options)
        setIsDataFetched(true) // Mark data as fetched
      })
  }, [aoa, data.site.siteMetadata])

  return (
    <div>
      {isDataFetched ? (
        <>
          <Dropdown
            placeholderText={spanish ? 'Seleccionar Estado' : 'Select State'}
            options={stateLinks}
            onChange={(e) => navigate(e.value)}
            {...props}
          />
          {stateLinks.map((current) => (
            <StyledLink href={current.value} key={current.value}>
              {current.label}
            </StyledLink>
          ))}
        </>
      ) : (
        <Dropdown
          placeholderText={spanish ? 'Seleccionar Estado' : 'Select State'}
        />
      )}
    </div>
  )
}

export default StateDropdown

const StyledLink = styled.a`
  display: none !important;
`
